import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';
import { TextareaModule } from 'primeng/textarea';

@Component({
  standalone: true,
  selector: 'pm-form-field-long-text',
  imports: [TextareaModule, ReactiveFormsModule],
  templateUrl: './pm-form-field-long-text.component.html',
  styleUrl: './pm-form-field-long-text.component.scss',
})
export class PmFormFieldLongTextComponent extends FormFieldComponent {
  @Input() rows = 5;
}
